import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Button(theme: Theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          '&:hover': {
            boxShadow: 'none'
          }
        },
        sizeLarge: {
          height: 48
        },
        sizeMedium: {
          minHeight: 36
        },
        containedInherit: {
          color: theme.palette.grey[800],
          boxShadow: theme.customShadows.z8,
          '&:hover': {
            backgroundColor: theme.palette.grey[400]
          }
        },
        containedPrimary: {
          boxShadow: 'none'
        },
        containedSecondary: {
          boxShadow: 'none'
        },
        containedInfo: {
          backgroundColor: '#AE397F',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: '#92408C'
          }
        },
        containedSuccess: {
          boxShadow: 'none'
        },
        containedWarning: {
          boxShadow: 'none'
        },
        containedError: {
          boxShadow: 'none'
        },
        // outlined
        outlinedInherit: {
          border: `1px solid ${theme.palette.grey[500_32]}`,
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          }
        },
        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          }
        }
      }
    }
  };
}
